import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import ShopSection from '../components/homeComponents/ShopSection';
import SchoolTabs from '../components/shopComponents/SchoolTabs';
import Footer from '../components/Footer';
import { listProducts } from '../service/ProductsService';
import Message from '../components/LoadingError/Error';
import Loading from '../components/LoadingError/Loading';
import { useParams, useSearchParams } from 'react-router-dom';
import { principalCategory } from '../constants/constantsValues';

const Shop = () => {
  const [products, setProducts] = useState();
  const [categoryProducts, setCategoryProducts] = useState();
  const [filteredProducts, setFilteredProducts] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [search, setSearch] = useState('');
  const [windowHeight, setWindowHeight] = useState();
  const [footerHeight, setFooterHeight] = useState();

  const params = useParams();
  const [searchParams] = useSearchParams();
  const shopId = params.id || searchParams.get('school');

  useEffect(() => {
    setWindowHeight(window.screen.height);
    listProducts()
      .then((products) => {
        setProducts(products);
      })
      .catch((e) => setError(e));
  }, []);

  useEffect(() => {
    if (shopId && products) {
      if (shopId === 'brainsInternacional') {
        const finalProducts = products.filter(
          (product) => product.category[0] === 'Brains Internacional'
        );
        setCategoryProducts(finalProducts);
      } else if (shopId === 'brainsNurserySchool') {
        const finalProducts = products.filter(
          (product) => product.category[0] === 'Brains Nursery School'
        );
        setCategoryProducts(finalProducts);
      } else {
        setCategoryProducts([]);
      }
      setLoading(false);
    }
  }, [products, shopId]);

  useEffect(() => {
    if (!shopId && principalCategory) {
      setSearch('');
      setLoading(false);
    }
  }, [shopId, principalCategory]);

  useEffect(() => {
    if (categoryProducts) {
      const productsCopy = [...categoryProducts];
      const productsSearched = [];
      productsCopy.filter(
        (product) =>
          product.name.toLowerCase().includes(search.toLowerCase()) &&
          productsSearched.push(product)
      );
      setFilteredProducts([...productsSearched]);
    }
  }, [categoryProducts, search]);

  useEffect(() => {
    if (windowHeight) {
      const divShop = document.getElementById('shop');
      const divShopHeight = divShop?.clientHeight;

      if (filteredProducts) {
        setFooterHeight(
          windowHeight &&
            divShopHeight < windowHeight * 0.8 &&
            windowHeight * 0.8 - divShopHeight
        );
      } else {
        setFooterHeight(
          windowHeight &&
            divShopHeight < windowHeight * 0.8 &&
            windowHeight * 0.8 - divShopHeight
        );
      }
    }
  }, [windowHeight, filteredProducts, shopId]);

  const filterProducts = (input) => {
    setSearch(input);
  };

  return (
    <div id='shopContainer'>
      {shopId ? (
        <div id='shop'>
          <Header filterProducts={filterProducts} />
          {principalCategory && <SchoolTabs categories={principalCategory} />}
          {error && <Message variant='alert-danger'>{error.message || error}</Message>}
          {loading ? (
            <div className='mb-5'>
              <Loading />
            </div>
          ) : (
            products &&
            categoryProducts &&
            filteredProducts && (
              <>
                <div className='container mt-4'>
                  <p className='text-muted mb-3'>
                    Mostrando {filteredProducts.length} producto{filteredProducts.length !== 1 ? 's' : ''}
                  </p>
                </div>
                <ShopSection products={filteredProducts} />
              </>
            )
          )}
        </div>
      ) : (
        <div id='shop'>
          <Header searcherDisabled={true} />
          {error && <Message variant='alert-danger'>{error.message || error}</Message>}
          {loading ? (
            <div className='mb-5'>
              <Loading />
            </div>
          ) : (
            principalCategory && <SchoolTabs categories={principalCategory} />
          )}
        </div>
      )}
      <div
        id='footerShop'
        className='d-flex flex-column justify-content-end'
        style={{
          height: footerHeight,
        }}
      >
        <Footer />
      </div>
    </div>
  );
};

export default Shop;
